import mem from "mem";

import { axiosPublic } from "./axiosPublic";

const refreshTokenFn = async () => {
    //const session = JSON.parse(localStorage.getItem("token"));

    try {
        let sessionLocal = JSON.parse(localStorage.getItem("token"));
        const response = await axiosPublic.post("/qr_backend/login/refresh/", {
            refresh: sessionLocal.refresh,
        });

        const { session } = response.data;
        sessionLocal.access = response.data.access;

        if (!session?.access) {
            localStorage.removeItem("token");
        }

        localStorage.setItem("token", JSON.stringify(sessionLocal));

        return sessionLocal;
    } catch (error) {
        let sessionLocal = JSON.parse(localStorage.getItem("token"));
        console.log(sessionLocal.refresh);
        localStorage.removeItem("token");
    }
};

const maxAge = 60000 * 60 * 24 * 30;

export const memorizedRefreshToken = mem(refreshTokenFn, {
    maxAge,
});